module.exports = __webpack_public_path__ + "static/media/404.207a8976.png";